import React from 'react'
import {connect} from 'react-redux'

import {watchMessageCounts, unwatchMessageCounts} from '../shared/data/watchers/message_counts'

class UnreadMessageCount extends React.Component {
  componentWillMount () {
    const {uid, conversationId} = this.props

    if (uid && conversationId) {
      this.props.watchMessageCounts(uid, conversationId)
    }
  }

  componentWillReceiveProps (nextProps) {
    const {uid, conversationId} = this.props
    const {uid: nextUid, conversationId: nextConversationId} = nextProps

    if (uid !== nextUid || conversationId !== nextConversationId) {
      this.props.rewatchMessageCounts(uid, conversationId, nextUid, nextConversationId)
    }
  }

  componentWillUnmount () {
    const {uid, conversationId} = this.props

    if (uid && conversationId) {
      this.props.unwatchMessageCounts(uid, conversationId)
    }
  }

  render () {
    if (this.props.shouldShowUnreadMessageCount && this.props.unreadMessageCount > 0) {
      return (
        <div className="unread-messages-count">
          {this.props.unreadMessageCount < 100 ? this.props.unreadMessageCount : '99+'}
        </div>
      )
    }
    else {
      return false
    }
  }
}

UnreadMessageCount.defaultProps = {
  unreadMessageCount: 0
}

const mapStateToProps = (state, ownProps) => {
  return {
    unreadMessageCount: state.getIn(['conversations', '_counts', ownProps.conversationId, 'unread'])
  }
}

const mapDispatchToProps = () => {
  return {
    watchMessageCounts: watchMessageCounts,
    unwatchMessageCounts: unwatchMessageCounts,
    rewatchMessageCounts: (uid, conversationId, nextUid, nextConversationId) => {
      if (uid && conversationId) unwatchMessageCounts(uid, conversationId)
      if (nextUid && nextConversationId) watchMessageCounts(nextUid, nextConversationId)
    }
  }
}

const UnreadMessageCountContainer = connect(
  mapStateToProps, mapDispatchToProps
)(UnreadMessageCount)

export default UnreadMessageCountContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/unread_message_count.js
 **/